import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgHoldingsWallet = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 72 73" {...props}><Path fill="currentColor" d="M5 7.5a5 5 0 0 0-5 5v1h63v-1a5 5 0 0 0-5-5H5ZM64 16.5H0v42a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-9H62a8 8 0 1 1 0-16h10v-9a8 8 0 0 0-8-8Z" /><Path fill="currentColor" d="M63 46.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" /></Svg>;
const Memo = memo(SvgHoldingsWallet);
export default Memo;